import { cva, VariantProps } from 'class-variance-authority';

export const menuContentVariants = cva(
  'z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-2 text-popover-foreground shadow-card-button animate-in data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
);

export const menuItemVariants = cva(
  'relative flex cursor-pointer w-full select-none items-center font-semibold gap-2 text-[14px] rounded-md p-2 outline-none transition-colors hover:bg-muted hover:text-foreground dark:hover:bg-muted/50 focus:bg-muted focus:text-foreground dark:focus:bg-muted/50 focus-visible:bg-muted focus-visible:text-foreground dark:focus-visible:bg-muted/50 data-[highlighted]:bg-muted data-[highlighted]:text-foreground dark:data-[highlighted]:bg-muted/50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      inset: {
        true: 'pl-8',
        false: '',
      },
    },
    defaultVariants: {
      inset: false,
    },
  },
);

export type ZardMenuContentVariants = VariantProps<typeof menuContentVariants>;
export type ZardMenuItemVariants = VariantProps<typeof menuItemVariants>;